import imageUrlBuilder from '@sanity/image-url';
import { client } from '../client';

const builder = imageUrlBuilder(client);

// biome-ignore lint/suspicious/noExplicitAny: <explanation>
export function urlForImage(source: any) {
  return builder.image(source).auto('format').fit('max');
}
